import React, { useEffect, useState } from "react";
import AppShell from "../components/layout/AppShell";
import api, { fmtMoney, fmtDate, fmtNum } from "../lib/api";
import { Warehouse, AlertTriangle, ArrowUpRight, ArrowDownRight } from "lucide-react";

export default function Stock() {
    const [movements, setMovements] = useState([]);
    const [alerts, setAlerts] = useState([]);

    useEffect(() => {
        Promise.all([api.get("/stock/movements"), api.get("/stock/alerts")])
            .then(([m, a]) => { setMovements(m.data); setAlerts(a.data); });
    }, []);

    return (
        <AppShell title="Stok" subtitle="Depo Yönetimi">
            {alerts.length > 0 && (
                <div className="bg-rose-50 dark:bg-rose-950/20 border border-rose-200 dark:border-rose-900 rounded-md p-4 mb-4">
                    <div className="flex items-center gap-2 text-rose-700 dark:text-rose-300 font-medium text-sm">
                        <AlertTriangle size={16}/> Kritik Stok Uyarısı ({alerts.length} ürün)
                    </div>
                    <div className="mt-3 grid md:grid-cols-3 gap-2">
                        {alerts.map(p => (
                            <div key={p.id} className="bg-card border border-border rounded p-3">
                                <div className="font-mono text-xs text-muted-foreground">{p.sku}</div>
                                <div className="font-medium text-sm">{p.name}</div>
                                <div className="text-xs mt-1">
                                    Mevcut: <b className="text-rose-600">{fmtNum(p.current_stock, 0)}</b> {p.unit} • Min: {fmtNum(p.min_stock, 0)}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <div className="bg-card border border-border rounded-md">
                <div className="p-4 border-b border-border">
                    <div className="text-sm font-medium">Stok Hareketleri</div>
                    <div className="text-xs text-muted-foreground">Mal kabul, çıkış ve transferler</div>
                </div>
                <div className="overflow-x-auto">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>Tarih</th><th>SKU</th><th>Hareket</th><th>Referans</th>
                                <th className="text-right">Miktar</th><th className="text-right">Birim Maliyet</th>
                                <th className="text-right">Bakiye</th><th>Depo</th>
                            </tr>
                        </thead>
                        <tbody>
                            {movements.map(m => (
                                <tr key={m.id}>
                                    <td>{fmtDate(m.created_at)}</td>
                                    <td className="font-mono text-xs">{m.sku}</td>
                                    <td>
                                        <span className={`inline-flex items-center gap-1 text-xs font-medium ${m.quantity > 0 ? "text-emerald-600" : "text-rose-600"}`}>
                                            {m.quantity > 0 ? <ArrowUpRight size={12}/> : <ArrowDownRight size={12}/>}
                                            {m.movement_type === "receipt" ? "Giriş" : m.movement_type === "issue" ? "Çıkış" : m.movement_type === "transfer" ? "Transfer" : "Düzeltme"}
                                        </span>
                                    </td>
                                    <td className="font-mono text-xs text-muted-foreground">{m.reference_number}</td>
                                    <td className={`text-right tabular-nums font-medium ${m.quantity > 0 ? "text-emerald-600" : "text-rose-600"}`}>
                                        {m.quantity > 0 ? "+" : ""}{fmtNum(m.quantity, 0)}
                                    </td>
                                    <td className="text-right tabular-nums">{fmtMoney(m.unit_cost)}</td>
                                    <td className="text-right tabular-nums font-medium">{fmtNum(m.balance_after, 0)}</td>
                                    <td>{m.warehouse}</td>
                                </tr>
                            ))}
                            {movements.length === 0 && (
                                <tr><td colSpan={8} className="text-center py-16 text-muted-foreground">
                                    <Warehouse size={28} className="mx-auto mb-2 opacity-40"/>
                                    Stok hareketi yok
                                </td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </AppShell>
    );
}
